import React, { Component } from 'react';
import Photo from './assets/img/profile_new.png';
import Particles from 'react-particles-js';

class LeftSide extends React.Component {
	
	constructor(){
		super();

		var tagClass = [];
	    let defaultTagClasses1 =["title", "mx-auto", "d-block",  "animated"];
	    let defaultTagClasses2 =["title", "mx-auto", "d-block",  "animated"];
	    let defaultTagClasses3 =["title", "mx-auto", "d-block",  "animated"];
	    tagClass.push(defaultTagClasses1);
	    tagClass.push(defaultTagClasses2);
	    tagClass.push(defaultTagClasses3);

		this.state = {isAnimated: false, selectedNum: [], isChanging: false, tagClass: tagClass};
		
		this.mouseEnterF = this.mouseEnterF.bind(this);
		this.mouseLeave = this.mouseLeave.bind(this);
		this.changeTag = this.changeTag.bind(this);
	}

	mouseEnterF(e, i){
		var nums = [];
		nums = this.state.selectedNum;
		console.log(this.state.selectedNum);
		var indexOfExisting = this.state.selectedNum.indexOf(e);
		
		if(indexOfExisting > -1){
			setTimeout(function() { nums = nums.splice(indexOfExisting, 1); }.bind(this), 1000);	
		}
		else{
			nums.push(e);
			this.setState({isAnimated: true	});
			this.setState({selectedNum: nums});
			var indexExisting = this.state.selectedNum.indexOf(e);
			setTimeout(function() { nums = nums.splice(indexExisting, 1); }.bind(this), 1000);
		}
		

		
	}

	mouseLeave(e,index){
	}

	changeTag(index, e){
		console.log(index);


		let tagClasses = this.state.tagClass;
	    
	    tagClasses[index].push("hinge");
	    this.setState({isChanging: false});
	    this.setState({tagClass: tagClasses});

	    console.log(index);
	    console.log(this.state.tagClass[index]);
	}

  render() {
  	let name = ["T","h", "a", "n", "o", "s", " ", "P", "a", "p", "p", "a", "s"];
  	let textClass = [];
  	for(var i=0;i<name.length;i++){
  		var classes = ["animated"];
  		textClass.push(classes);
  	}
    if(this.state.isAnimated && this.state.selectedNum.length > 0) {

      for(var i=0;i<this.state.selectedNum.length;i++){
      	textClass[this.state.selectedNum[i]].push('rubberBand');	
      }
      
    }



    return (
    		<div className="col-md-5 col-sm-12 col-12 left-side">
    		

			<div className="profile">
				<img className="mx-auto d-block photo-profile" src={Photo}/>
				

				<div className="title mx-auto d-block">
					<h2 className="animated bounceIn" style={{display:''}}>Coffee addict</h2>
				</div>

				<div className={this.state.tagClass[2].join(' ')}>
					<h2 className="animated">Peaky Blinders Fan 
					<span className="changeTag" title="Close" onClick={this.changeTag.bind(this,2)}> 
					<i className="fas fa-times"></i> </span></h2>
				</div>

				<div className={this.state.tagClass[1].join(' ')}>
					<h2 className="animated">Big Data Engineer 
					<span className="changeTag" title="Close" onClick={this.changeTag.bind(this,1)}> 
					<i className="fas fa-times"></i> </span></h2>
				</div>

				<div className={this.state.tagClass[0].join(' ')}>
					<h2 className="animated">Full Stack Developer 
					<span className="changeTag" title="Close" onClick={this.changeTag.bind(this,0)}> 
					<i className="fas fa-times"></i> </span></h2>
				</div>

				<div className="name">

					<h1 className="animation-target33">
						{name.map((letter, index) => {
							if(letter == ' '){
								return (<span id={index} style={{display:'inline-block'}} className={textClass.join(' ')} 
								onMouseEnter={this.mouseEnterF.bind(this, index)}>
				                &nbsp;</span>);
							}
							return (<span id={index} style={{display:'inline-block'}} className={textClass[index].join(' ')} 
								onMouseEnter={this.mouseEnterF.bind(this, index)} onMouseLeave={this.mouseLeave.bind(this,index)}>
				{letter}</span>);

						})}

					</h1>
				</div>

				<p>Full Stack Developer who focuses on writing clean, extensible and efficient code. He is transforming cups of coffee to extensible clean code trying to make the web a better place.</p>
				
	  			<p><i className="fas fa-paper-plane"></i> info &#123;at&#125; thanos-pappas.com <span className="float-right">
	  			<a className="linkedin" href="http://gr.linkedin.com/in/thanosspappas" target="_blank"><i className="fab fa-linkedin social-icon"></i></a>
	  			<a className="insta" href="https://www.instagram.com/thanospappass/" target="_blank"><i className="fab fa-instagram social-icon"></i></a>
	  			<a className="github" href="https://github.com/thanospappas/" target="_blank"><i className="fab fa-github-square social-icon"></i></a></span></p>

			</div>
			 <div className="bgParticles">
				<Particles className="particles" params={{
				  "particles": {
				    "number": {
				      "value":100,
				      "density": {
				        "enable": true,
				        "value_area": 1420.4657549380909
				      }
				    },
				    "color": {
				      "value": "#313232"
				    },
				    "shape": {
				      "type": "circle",
				      "stroke": {
				        "width": 0,
				        "color": "#313232"
				      },
				      "polygon": {
				        "nb_sides": 5
				      },
				      "image": {
				        "src": "img/github.svg",
				        "width": 100,
				        "height": 100
				      }
				    },
				    "opacity": {
				      "value": .8,
				      "random": false,
				      "anim": {
				        "enable": false,
				        "speed": 1,
				        "opacity_min": 0.1,
				        "sync": false
				      }
				    },
				    "size": {
				      "value": 4.008530152163807,
				      "random": true,
				      "anim": {
				        "enable": false,
				        "speed": 40,
				        "size_min": 0.1,
				        "sync": false
				      }
				    },
				    "line_linked": {
				      "enable": true,
				      "distance": 192.40944730386272,
				      "color": "#313232",
				      "opacity": 1,
				      "width": 0.16034120608655228
				    },
				    "move": {
				      "enable": true,
				      "speed": 6,
				      "direction": "none",
				      "random": false,
				      "straight": false,
				      "out_mode": "out",
				      "bounce": false,
				      "attract": {
				        "enable": false,
				        "rotateX": 600,
				        "rotateY": 1200
				      }
				    }
				  },
				  "interactivity": {
				    "detect_on": "canvas",
				    "events": {
				      "onhover": {
				        "enable": false,
				        "mode": "repulse"
				      },
				      "onclick": {
				        "enable": false,
				        "mode": "push"
				      },
				      "resize": true
				    },
				    "modes": {
				      "grab": {
				        "distance": 400,
				        "line_linked": {
				          "opacity": 1
				        }
				      },
				      "bubble": {
				        "distance": 400,
				        "size": 40,
				        "duration": 2,
				        "opacity": 8,
				        "speed": 3
				      },
				      "repulse": {
				        "distance": 200,
				        "duration": 0.4
				      },
				      "push": {
				        "particles_nb": 4
				      },
				      "remove": {
				        "particles_nb": 2
				      }
				    }
				  },
				  "retina_detect": true
				}}/>
			</div>
  
		</div>


    	);
  }
}
export default LeftSide;


// WEBPACK FOOTER //
// ./src/LeftSide.js